import moment from 'moment';
import {
    DecisionModel,
    ClientModel as ModelApiT,
    ConversionModel,
    PriceModel,
    RiskModel,
    DataRobot,
    isRiskModel,
    isPriceModel,
    isDecisionModel,
    isConversionModel,
    UnderwriteModel, BidWinRateModel, isBidWinRateModel
} from "../features/models/api/api-types";
import { Model, RiskBasedCredit } from '../features/models/types/model';


export const toCredentials = <C extends DataRobot>(c: C) => {
    if (c === null) {
        return null;
    }
    return {
        ...c,
        project: c.isLegacy === true ? c.project : '',
        model: c.isLegacy === true ? c.model : '',
        deployment: c.isLegacy === false ? c.deployment : '',
    };
};

export const getCredentials = (m: ModelApiT<DecisionModel> | ModelApiT<PriceModel> | ModelApiT<RiskModel> | ModelApiT<BidWinRateModel> | ModelApiT<ConversionModel>) => {
    if (isDecisionModel(m)) {
        return toCredentials(m.decision?.dataRobot ?? null);
    } else if (isPriceModel(m)) {
        return toCredentials(m.price?.dataRobot ?? null);
    } else if (isRiskModel(m)) {
        return toCredentials(m.risk?.dataRobot ?? null);
    } else if(isBidWinRateModel(m)){
        return toCredentials(m.bidWinRate?.dataRobot ?? null);
    } else if(isConversionModel(m)){
        return toCredentials(m.conversion?.dataRobot ?? null);
    }
     else {
        throw new Error('Error with getting credentials');
    }
};

interface DataRobotApi {
    project: string;
    model: string;
    deployment: string;
    isLegacy: boolean;
}

export type ApiModel = Model & {
    risk?: RiskBasedCredit;
    dataRobot?: DataRobotApi;
};

export function toModel(model: UnderwriteModel): Model | null {
    return {
        ...model,
        ...(model.modelType === 'Price' && {
            price: { ...model.price },
        }),
        ...(model.modelType === 'Decision' && {
            decision: { ...model.decision },
        }),
        ...(model.modelType === 'Risk' && {
            risk: { ...model.risk },
        }),
        ...(model.modelType === 'BidWinRate' && {
            risk: { ...model.bidWinRate },
        }),
        ...(model.modelType === 'Conversion' && {
            conversion: { ...model.conversion },
        }),
        groupId: model.groupId ?? null,
        groupWeight: model.groupWeight ?? null,
        activeStart: moment(model.activeStart),
        activeEnd: moment(model.activeEnd),
    };
}

